import { Button } from '@mui/material';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import queryString from 'query-string';
import React from 'react';
import { useLocation } from 'react-router';

import allpatientsImage from '../../../assets/images/Login/allPatientsInPortal.svg?url';
import { useLoginService } from '../../../services/loginService';
import { useSignUpService } from '../../../services/signUpService';
import formStyles from '../../Login/LoginContent/index.module.scss';
import styles from './index.module.scss';

function PatientDataContent() {
  const { hash } = useLocation();

  const {
    state: { signUpFlowState },
  } = useSignUpService();
  const { redirectToApp } = useLoginService();

  const urlParams = queryString.parse(hash);
  const idToken = urlParams?.id_token as string;

  return (
    <div
      className={classNames(
        styles.contentDataContainer,
        'flex flex-col text-base font-normal text-neutrals-n-400 w-1/2 items-center pl-4 gap-4',
      )}
    >
      <div className="mb-2 pl-2">
        To review patient data on your computer go to the{' '}
        <span className="font-bold text-secondary-s-500">clinical portal.</span>
      </div>
      <img src={allpatientsImage} alt="allpatients" className={styles.patientsImage} />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classNames(
          formStyles.submitBtn,
          styles.submitBtn,
          'rounded-4',
          'self-end mt-8',
        )}
        onClick={() => (idToken ? redirectToApp({ idToken }) : signUpFlowState?.onLogin?.())}
      >
        Continue to portal
      </Button>
    </div>
  );
}
export default observer(PatientDataContent);
